export default __webpack_public_path__ + "static/B0311-0e94afef25d57ca22f71f84e9e227652.png";